import { isNil } from 'lodash';
import {
    Coupon,
} from '../models';
import ActionType from './list.actionTypes';

export const DEFAULT_STATE: Coupon[] = [];

export default (
    state: Coupon[] | undefined,
    action: any,
): Coupon[] => {
    if (state === undefined) {
        return DEFAULT_STATE;
    }

    if (!isNil(action)) {
        switch (action.type) {
            case ActionType.SET_EVENT_COUPON_LIST: {
                const { value: list } = action;

                return list;
            }

            default:
                return state;
        }
    }

    return state;
};
